import { render, staticRenderFns } from "./BreakdownCharts.vue?vue&type=template&id=2a70905d&scoped=true&"
import script from "./BreakdownCharts.vue?vue&type=script&lang=js&"
export * from "./BreakdownCharts.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownCharts.vue?vue&type=style&index=0&id=2a70905d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70905d",
  null
  
)

export default component.exports